import objectPrefix from '../../lib/objectPrefix';

const prefix = objectPrefix();
const height = '31.5%';

module.exports = {
    laserGuy1: {
        type: 'movieclip',
        scale: {
            y: '48%',
        },
        position: {
            x: '-26%',
            y: height,
        },
        texture: `sprite:/img/partials/blobs-treadmill/laser-guy-${prefix}.json,laser-guy/1`,
        effectSpriteKey: 'laserGuyEffect',
        effectPositions: [
            [
                {
                    position: {
                        x: '49.3%',
                        y: '36.3%',
                    },
                    rotation: -5,
                },
                {
                    position: {
                        x: '53.1%',
                        y: '36.1%',
                    },
                    rotation: -25,
                },
            ],
            [{}],
            [
                {
                    position: {
                        x: '47%',
                        y: '35.8%',
                    },
                    rotation: 7,
                },
                {
                    position: {
                        x: '50.7%',
                        y: '35.8%',
                    },
                    rotation: -7,
                },
            ],
            [{}],
            [
                {
                    position: {
                        x: '46.3%',
                        y: '36.7%',
                    },
                    rotation: 30,
                },
                {
                    position: {
                        x: '49.3%',
                        y: '37.1%',
                    },
                    rotation: 11,
                },
            ],
            [{}],
            [{}],
            [
                {
                    position: {
                        x: '51.3%',
                        y: '37.5%',
                    },
                    rotation: -12,
                },
                {
                    position: {
                        x: '54.8%',
                        y: '37.5%',
                    },
                    rotation: -27,
                },
            ],
            [{}],
            [
                {
                    position: {
                        x: '48.4%',
                        y: '36.7%',
                    },
                    rotation: 3,
                },
                {
                    position: {
                        x: '52%',
                        y: '36.9%',
                    },
                    rotation: -6,
                },
            ],
        ],
    },

    laserGuy2: {
        type: 'movieclip',
        scale: {
            y: '48%'
        },
        position: {
            x: '-26%',
            y: height,
        },
        texture: `sprite:/img/partials/blobs-treadmill/laser-guy-${prefix}.json,laser-guy/2`,
        effectSpriteKey: 'laserGuyEffect',
        effectPositions: [
            [{}],
            [
                {
                    position: {
                        x: '42.9%',
                        y: '41.7%'
                    },
                    rotation: 22
                },
                {
                    position: {
                        x: '46.2%',
                        y: '42.4%'
                    },
                    rotation: 9
                }
            ],
            [
                {
                    position: {
                        x: '47%',
                        y: '40.7%'
                    },
                    rotation: 1
                },
                {
                    position: {
                        x: '50.8%',
                        y: '40.7%'
                    },
                    rotation: -1
                }
            ],
            [{}],
            [
                {
                    position: {
                        x: '51.8%',
                        y: '41.1%'
                    },
                    rotation: -2
                },
                {
                    position: {
                        x: '55.5%',
                        y: '41.1%'
                    },
                    rotation: -10
                }
            ],
            [
                {
                    position: {
                        x: '54.2%',
                        y: '41.1%'
                    },
                    rotation: -5
                },
                {
                    position: {
                        x: '58%',
                        y: '40.9%'
                    },
                    rotation: -25
                }
            ]
        ]
    },

    laserGuy3: {
        type: 'movieclip',
        scale: {
            y: '48%'
        },
        position: {
            x: '-26%',
            y: height,
        },
        texture: `sprite:/img/partials/blobs-treadmill/laser-guy-${prefix}.json,laser-guy/3`,
        effectSpriteKey: 'laserGuyEffect',
        effectPositions: [
            [{}],
            [{}],
            [
                {
                    position: {
                        x: '40.7%',
                        y: '46.4%'
                    },
                    rotation: 13
                },
                {
                    position: {
                        x: '44.4%',
                        y: '46.2%'
                    },
                    rotation: 0
                }
            ],
            [
                {
                    position: {
                        x: '48.7%',
                        y: '47.9%'
                    },
                    rotation: 2
                },
                {
                    position: {
                        x: '52.5%',
                        y: '47.9%'
                    },
                    rotation: -3
                }
            ],
            [
                {
                    position: {
                        x: '55.9%',
                        y: '49.4%'
                    },
                    rotation: -2
                },
                {
                    position: {
                        x: '59.6%',
                        y: '49.4%'
                    },
                    rotation: -8
                }
            ],
            [{}],
            [
                {
                    position: {
                        x: '55.2%',
                        y: '50.4%'
                    },
                    rotation: -1
                },
                {
                    position: {
                        x: '58.9%',
                        y: '50.6%'
                    },
                    rotation: -5
                }
            ],
            [
                {
                    position: {
                        x: '48%',
                        y: '50.8%'
                    },
                    rotation: 7
                },
                {
                    position: {
                        x: '51.8%',
                        y: '50.6%'
                    },
                    rotation: 0
                }
            ],
            [
                {
                    position: {
                        x: '41%',
                        y: '50%'
                    },
                    rotation: 30
                },
                {
                    position: {
                        x: '44.4%',
                        y: '50.4%'
                    },
                    rotation: 15
                }
            ],
            [
                {
                    position: {
                        x: '36%',
                        y: '51.5%'
                    },
                    rotation: 40
                },
                {
                    position: {
                        x: '39.1%',
                        y: '51.5%'
                    },
                    rotation: 20
                }
            ]
        ]
    },

    laserGuyEffect: {
        scale: {
            y: '50%'
        },
        anchor: {
            x: 0.5,
            y: 0
        },
        texture: '/img/partials/blobs-treadmill/laser-effect.png',
        count: 2,
    }
};



// WEBPACK FOOTER //
// ./js/objects/partials/laserGuy.js